import Point from './Point';
import Scale from './Scale';
import Bounds from './Bounds';

declare type Offset = { x: number, y: number };
declare type Size = { width: number, height: number };

export const DEFAULT_SCALE = { xFactor: 1, yFactor: 1 };

function toLogicalPoint(canvas: HTMLCanvasElement, physicalPoint: Point, scale: Scale, physicalOffset?: Offset) {

	// A veces usamos un canvas de mayor tamaño lógico que físico para mejorar la calidad
	// en pantallas retina. En esos casos width/height son el tamaño "lógico" del mapa, y
	// style.width/style.height el tamaño físico. Necesito ajustar el punto lógico teniendo
	// en cuenta también ese factor.

	const usedDevicePixelRatioX = canvas.style.width
		? canvas.width / parseInt(canvas.style.width.replace('px', ''))
		: 1;

	const usedDevicePixelRatioY = canvas.style.height
		? canvas.height / parseInt(canvas.style.height.replace('px', ''))
		: 1;

	const logicalOffset = {
		x: physicalOffset ? physicalOffset.x * scale.xFactor : 0,
		y: physicalOffset ? physicalOffset.y * scale.yFactor : 0
	};

	return {
		x: usedDevicePixelRatioX * (physicalPoint.x - logicalOffset.x) / scale.xFactor,
		y: usedDevicePixelRatioY * (physicalPoint.y - logicalOffset.y) / scale.yFactor
	};
}

function getPhysicalMousePoint(canvas: HTMLCanvasElement, e: React.MouseEvent<HTMLCanvasElement>): Point {
	const rect = canvas.getBoundingClientRect();
	return {
		x: e.clientX - rect.left,
		y: e.clientY - rect.top
	};
}

function getPhysicalTouchPoint(canvas: HTMLCanvasElement, e: React.TouchEvent<HTMLCanvasElement>): Point {
	const rect = canvas.getBoundingClientRect();
	return {
		x: e.touches[0].clientX - rect.left,
		y: e.touches[0].clientY - rect.top
	};
}

export function getScale(canvas: HTMLCanvasElement, realSize: Size): Scale {
	return { xFactor: canvas.width / realSize.width, yFactor: canvas.height / realSize.height };
}

export function containsPoint(bounds: Bounds, point: Point) {
	return point.x >= bounds.x && point.x <= bounds.x + bounds.width && point.y >= bounds.y && point.y <= bounds.y + bounds.height;
}

export function containedIn(containerBounds: Bounds, bounds: Bounds): boolean {
	return bounds.x <= containerBounds.x + containerBounds.width &&
		bounds.x + bounds.width > containerBounds.x &&
		bounds.y <= containerBounds.y + containerBounds.height &&
		bounds.y + bounds.height > containerBounds.y;
}

export function getLogicalMousePoint(canvas: HTMLCanvasElement, e: React.MouseEvent<HTMLCanvasElement>, scale: Scale = DEFAULT_SCALE, physicalOffset: Offset = { x: 0, y: 0 }): Point {
	const physicalPoint = getPhysicalMousePoint(canvas, e);
	return toLogicalPoint(canvas, physicalPoint, scale, physicalOffset);
}

export function getLogicalTouchPoint(canvas: HTMLCanvasElement, e: React.TouchEvent<HTMLCanvasElement>, scale: Scale = DEFAULT_SCALE, physicalOffset: Offset = { x: 0, y: 0 }): Point {
	const physicalPoint = getPhysicalTouchPoint(canvas, e);
	return toLogicalPoint(canvas, physicalPoint, scale, physicalOffset);
}